import React from "react"

import { useTranslation } from "@bounce/i18n"
import type { ImgixParams } from "@bounce/web-components"
import { Button, Link, PostSlider } from "@bounce/web-components"

import type { FormattedBlogPostPreview } from "../../../libs/prismic/types"
import { blogPostToPostCard } from "../../../utils/blogPost"
import { useSectionViewed } from "@/hooks/useSectionViewed"

export type ArticleSuggestionsProps = {
  relatedArticles: FormattedBlogPostPreview[]
  title: string
  className?: string
  imgixParams?: ImgixParams
}

export const ArticleSuggestions = ({ relatedArticles, title, className, imgixParams }: ArticleSuggestionsProps) => {
  const { sectionRef } = useSectionViewed({ name: "Articles" })
  const { t } = useTranslation("marketing-ls-city")

  if (!relatedArticles.length) return null

  const formattedArticles = relatedArticles.map(blogPostToPostCard)

  return (
    <PostSlider
      items={formattedArticles}
      sliderTitle={title}
      imgixParams={imgixParams}
      sectionRef={sectionRef}
      className={className}
      footer={
        <Button as={Link} className="whitespace-normal !p-0 text-left" href="/blog" variant="ghost">
          {t("screen.articlesScreen.articleSuggestions.readMoreArticles", "Read more articles")}
        </Button>
      }
    />
  )
}
